import { useCallback } from 'react';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

export const useLogClickSearch = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback(() => {
    logMarketAnalytics({
      name: 'CLICK_SEARCH',
    });
  }, [logMarketAnalytics]);
};
